<template>
    <div class="question-box">
        <div
            class="question-progress"
            :style="{ top: $showTitle ? '46px' : '0' }"
        >
            <van-progress
                :percentage="((index + 1) / length) * 100"
                :show-pivot="false"
            />
        </div>

        <div
            class="question-bg"
            :style="{ top: $showTitle ? '46px' : '0' }"
        ></div>
        <component
            :is="QUESTIONES[index].component"
            v-bind="QUESTIONES[index].props()"
            :index="index"
            :next="next"
            :back="back"
        ></component>
    </div>
</template>

<script>
import qs from "qs";
import { saveLG } from "../../services/lg.js";
import { getUserAnswer, userAnswer } from "../../services/question.js";

import envs from "../../utils/envs.js";
import { getEnvName } from "../../utils/env.js";
import store from "../../store/index.js";
import { ANSWER } from "../../store/mutation-types.js";
import {
    commonSaveEvaluateInfo,
    saveEvaluateInfo,
} from "../../services/question.js";
import { QUESTIONES } from "./QUESTIONES.js";

export default {
    data() {
        this.QUESTIONES = QUESTIONES;
        this.length = QUESTIONES.length;
        return {
            index: 0,
        };
    },
    created() {
        const answer = store.state.answer;
        getEnvName().then((envName) => {
            envs[envName]?.login
                .isLogin()
                .then(() => {
                    this.$store.dispatch("GET_RELATE_INFO");
                    getUserAnswer(() => {
                        store.commit(ANSWER, {
                            idx: "complete",
                            value: 0,
                        });
                        store.commit(ANSWER, {
                            idx: "questionNumber",
                            value: 0,
                        });
                        saveEvaluateInfo(answer);
                    });
                })
                .catch(() => {
                    saveEvaluateInfo(answer);
                });
        });
    },
    computed: {
        isLast() {
            return this.index === this.length - 1;
        },
    },
    watch: {
        index: {
            immediate: true,
            handler(n, o) {
                this.sensorsAdd("BDpageview", {
                    $title: `测评页-第${n}题`,
                });
                o !== undefined &&
                    this.sensorsAdd("pageviewStay", {
                        $title: `测评页-第${o}题`,
                        $event_duration:
                            (new Date().getTime() - this.baseTime) / 1000,
                    });

                this.baseTime = new Date().getTime();
            },
        },
    },
    methods: {
        next() {
            const answer = store.state.answer;
            if (this.isLast) {
                store.commit(ANSWER, {
                    idx: "complete",
                    value: 1,
                });
                store.commit(ANSWER, {
                    idx: "questionNumber",
                    value: this.index + 1,
                });
                // TODO：执行提交方法，不写在某个具体的组件内，如果需要校验整体数据，写在内部
                getEnvName().then((envName) => {
                    envs[envName]?.login.isLogin().then(
                        () => {
                            commonSaveEvaluateInfo(answer)().then(() => {
                                this.sensorsAdd("pageviewStay", {
                                    $title: `测评页-第${this.index}题`,
                                    $event_duration:
                                        (new Date().getTime() - this.baseTime) /
                                        1000,
                                });
                                this.$router.push("/user-report");
                            });
                        },
                        () => {
                            envs[envName]?.login.goToLogin(this);
                        }
                    );
                });
            } else {
                store.commit(ANSWER, {
                    idx: "questionNumber",
                    value: ++this.index,
                });
                saveEvaluateInfo(answer);
            }
        },
        back(e) {
            const text = e.target.innerText;
            console.log(`测评页-第${this.index}题:`, text);
            this.sensorsAdd("BDWebClick", {
                $element_content: text,
                $title: `测评页-第${this.index}题`,
            });
            --this.index;
        },
    },
    destroyed() {
        //获客版测评未完成发送LG
        let { tmrId } = qs.parse(location.search.slice(1));
        const { relateInfo, answer } = store.state;

        !tmrId &&
            !this.isLast &&
            relateInfo.isRelate &&
            saveLG({
                method: 5,
                userAnswer: userAnswer(answer),
            });
        if (answer.complete == 0 && answer.questionNumber != 0) {
            saveEvaluateInfo(answer);
        }
    },
};
</script>

<style>
.question-box {
    height: 100vh;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
}
.question-box .content-tip {
    width: 3.13rem;
    margin: 0.75rem auto 0.25rem;
    padding: 0.14rem;
    background: white;
    border-radius: 0.1rem;
    box-sizing: border-box;
    font-size: 0.12rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #617080;
    line-height: 0.19rem;
    position: relative;
    box-shadow: 0rem 0.1rem 0.06rem #ebedf0;
}
.question-box .content-tip > p {
    font-size: 0.12rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #617080;
    line-height: 0.19rem;
}
.question-box .content-tip::before {
    display: block;
    content: "";
    width: 1rem;
    height: 0.6rem;
    position: absolute;
    top: -0.58rem;
    left: 0;
    background: url("./jqr@2x.png") no-repeat center;
    background-size: cover;
}
.question-box .title {
    font-size: 0.15rem;
    font-family: PingFang SC;
    font-weight: bold;
    color: #0f2742;
    line-height: 0.19rem;
    text-align: center;
}
</style>

<style scoped>
.question-bg {
    position: fixed;
    width: 100vw;
    top: 0;
    bottom: 0;
    z-index: -1;
    background-image: url(./BG@2x.png);
    background-size: 100%;
    background-repeat: no-repeat;
}
.question-progress {
    position: fixed;
    width: 100%;
    top: 46px;
    left: 0;
    z-index: 1;
}
.question-c {
    padding-bottom: 0.5rem;
}
</style>
